var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCloudUploadAlt, faFile, faTrashAlt } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Link, Typography, styled } from '@mui/material';
import moment from 'moment';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';
import { PlanType } from '../../enum';
import { MAX_FILE_SIZE } from './constants';
import { defaultFormValues } from './createPlan';
var UploadBox = styled(Box)(function (_a) {
  var theme = _a.theme;
  return {
    border: "0.1rem dashed ".concat(theme.palette.text.primary),
    borderRadius: 1,
    padding: 10,
    textAlign: 'center'
  };
});
var FileNameBox = styled(Box)(function (_a) {
  var theme = _a.theme;
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: "1px solid ".concat(theme.palette.grey[500]),
    borderRadius: 1,
    marginTop: 10,
    padding: 5
  };
});
export var UploadTemplateDialog = function (_a) {
  var open = _a.open,
    onClose = _a.onClose,
    handleUploadComplete = _a.handleUploadComplete,
    uploadedFile = _a.uploadedFile,
    setUploadedFile = _a.setUploadedFile,
    setValue = _a.setValue;
  var t = useTranslation(['myPlans', 'translation']).t;
  var _b = useState(),
    rejectFile = _b[0],
    setRejectFile = _b[1];
  var _c = useState(defaultFormValues),
    excelValues = _c[0],
    setExcelValues = _c[1];
  var inputFile = useRef(null);
  useEffect(function () {
    if (!uploadedFile && inputFile.current) {
      var dataTransfer = new DataTransfer();
      inputFile.current.files = dataTransfer.files;
    }
  }, [uploadedFile]);
  var validateFile = useCallback(function (uploadFile) {
    return __awaiter(void 0, void 0, void 0, function () {
      var arrayBuffer, workbook, sheetName, worksheet, jsonData, date, uploadPlanTypeCategory, uploadPlanType, uploadPeriodLength, errors;
      var _a, _b, _c, _d;
      return __generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            if (!uploadFile) return [2 /*return*/];
            return [4 /*yield*/, uploadFile.arrayBuffer()];
          case 1:
            arrayBuffer = _e.sent();
            workbook = XLSX.read(arrayBuffer, {
              type: 'array'
            });
            sheetName = workbook.SheetNames[1];
            worksheet = workbook.Sheets[sheetName];
            jsonData = XLSX.utils.sheet_to_json(worksheet, {
              header: 'A',
              raw: false
            });
            date = moment.utc((_a = jsonData[3]) === null || _a === void 0 ? void 0 : _a.B, 'MM DD YYYY');
            uploadPlanTypeCategory = t((_b = jsonData[3]) === null || _b === void 0 ? void 0 : _b.F, {
              ns: 'translation',
              lng: 'en'
            });
            uploadPlanType = t((_c = jsonData[5]) === null || _c === void 0 ? void 0 : _c.B, {
              ns: 'translation',
              lng: 'en'
            });
            uploadPeriodLength = Number((_d = jsonData[5]) === null || _d === void 0 ? void 0 : _d.F);
            errors = [];
            if (!date.isValid() || !uploadPlanType || !uploadPeriodLength || !uploadPlanTypeCategory) {
              errors.push({
                code: 'invalid-excel-values',
                message: 'Invalid excel values'
              });
            }
            if (date.isValid() && date.date() !== 1 && uploadPlanType !== PlanType.Weekly) {
              errors.push({
                code: 'invalid-start-date',
                message: 'Plan start date must be the first day of the month'
              });
            }
            if (errors.length) {
              setRejectFile({
                file: uploadFile,
                errors: errors
              });
            } else {
              setUploadedFile(uploadFile);
              setExcelValues(__assign(__assign({}, excelValues), {
                startDate: date,
                planTypeCategory: uploadPlanTypeCategory,
                planType: uploadPlanType,
                periodLength: uploadPeriodLength
              }));
            }
            return [2 /*return*/];
        }
      });
    });
  }, [excelValues, setUploadedFile, t]);
  var formatFileSize = function (bytes) {
    if (bytes < 1024) {
      return bytes + ' bytes';
    } else if (bytes < 1024 * 1024) {
      return (bytes / 1024).toFixed(2) + ' KB';
    }
    return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
  };
  var onDrop = useCallback(function (acceptedFiles, rejectedFiles) {
    setUploadedFile(undefined);
    setRejectFile(rejectedFiles[0]);
    validateFile(acceptedFiles[0]);
  }, [setUploadedFile, validateFile]);
  var _d = useDropzone({
      accept: {
        'application/vnd.ms-excel': ['.xls'],
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
      },
      maxSize: MAX_FILE_SIZE,
      onDrop: onDrop,
      noClick: true,
      noKeyboard: true
    }),
    getRootProps = _d.getRootProps,
    getInputProps = _d.getInputProps,
    isDragActive = _d.isDragActive;
  var handleClose = function () {
    onClose();
    setRejectFile(undefined);
  };
  var handleDoneClick = function () {
    if (!uploadedFile) return;
    setValue('planTypeCategory', t(excelValues.planTypeCategory, {
      ns: 'translation',
      lng: 'en'
    }), {
      shouldValidate: true
    });
    setValue('startDate', excelValues.startDate, {
      shouldValidate: true
    });
    setValue('planType', t(excelValues.planType, {
      ns: 'translation',
      lng: 'en'
    }), {});
    setValue('periodLength', excelValues.periodLength, {
      shouldValidate: true
    });
    handleUploadComplete();
  };
  var handleBrowseClick = function () {
    var _a;
    (_a = inputFile.current) === null || _a === void 0 ? void 0 : _a.click();
  };
  var getFileUploadErrorMessage = function () {
    var _a, _b;
    var code = (_b = (_a = rejectFile === null || rejectFile === void 0 ? void 0 : rejectFile.errors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.code;
    var errorMessageMap = {
      'file-invalid-type': 'upload.invalidFileType',
      'file-too-large': 'upload.invalidSize',
      'invalid-excel-values': 'upload.invalidFileFormat',
      'invalid-start-date': 'upload.invalidStartDate'
    };
    var i18nKey = code ? errorMessageMap[code] : undefined;
    return _jsx("span", {
      children: t(i18nKey !== null && i18nKey !== void 0 ? i18nKey : 'upload.invalidFileFormat')
    });
  };
  return _jsxs(Dialog, __assign({
    open: open,
    onClose: handleClose,
    disablePortal: true
  }, {
    children: [_jsx(DialogTitle, __assign({
      variant: "h2"
    }, {
      children: t('upload.uploadFile')
    })), _jsxs(DialogContent, __assign({
      sx: {
        paddingBottom: 0
      }
    }, {
      children: [_jsxs(UploadBox, __assign({}, getRootProps(), {
        children: [_jsx("input", __assign({
          "data-testid": "drop-input"
        }, getInputProps(), {
          accept: ".xls,.xlsx",
          ref: inputFile
        })), _jsx(FontAwesomeIcon, {
          icon: faCloudUploadAlt,
          size: "2x"
        }), isDragActive ? _jsx(Typography, {
          children: t('upload.dropFileHere')
        }) : _jsxs(Typography, {
          children: [_jsx(Link, __assign({
            "data-testid": "link-btn",
            component: "button",
            onClick: handleBrowseClick
          }, {
            children: t('upload.browse')
          })), t('upload.orDragAndDropHere')]
        }), _jsx(Typography, __assign({
          color: "text.secondary",
          variant: "body2"
        }, {
          children: t('upload.sizeLimit')
        })), _jsx(Typography, __assign({
          color: "text.secondary",
          variant: "body2"
        }, {
          children: t('upload.fileType')
        }))]
      })), uploadedFile && _jsxs(FileNameBox, {
        children: [_jsxs(Box, __assign({
          sx: {
            display: 'flex',
            alignItems: 'center'
          }
        }, {
          children: [_jsx(Box, {
            children: _jsx(FontAwesomeIcon, {
              icon: faFile,
              size: "xl"
            })
          }), _jsxs(Box, __assign({
            ml: 2
          }, {
            children: [_jsx(Typography, __assign({
              variant: "body2"
            }, {
              children: uploadedFile.name
            })), _jsx(Typography, __assign({
              variant: "body2"
            }, {
              children: formatFileSize(uploadedFile.size)
            }))]
          }))]
        })), _jsx(Link, __assign({
          component: IconButton,
          size: "small",
          onClick: function () {
            return setUploadedFile(undefined);
          }
        }, {
          children: _jsx(FontAwesomeIcon, {
            icon: faTrashAlt
          })
        }))]
      }), rejectFile && _jsx(Typography, __assign({
        mt: 3,
        color: "error.dark",
        variant: "body2"
      }, {
        children: getFileUploadErrorMessage()
      }))]
    })), _jsxs(DialogActions, __assign({
      sx: {
        justifyContent: 'space-between'
      }
    }, {
      children: [_jsx(Button, __assign({
        "data-testid": "cancel-btn",
        variant: "outlined",
        onClick: handleClose
      }, {
        children: t('translation:action.cancel')
      })), _jsx(Button, __assign({
        "data-testid": "done-btn",
        variant: "contained",
        type: "submit",
        onClick: handleDoneClick,
        disabled: !uploadedFile
      }, {
        children: t('translation:action.done')
      }))]
    }))]
  }));
};